import React from "react";
import "../../common/card/styles.css";
import ChangeIndicator from "../change-indicator/change-indicator.js";
import Text from "../typography/text.js";
import RightArrowIcon from "../../icons/right-arrow.js";
import { Skeleton } from "antd";

// Amounts reach us as numbers or as pre-formatted strings ("$46,022").
// Strings must be coerced first: String.prototype.toLocaleString ignores the
// fraction-digit options entirely and would pass the value through with no cents.
export const formatNumber = (value) => {
  const numericValue =
    typeof value === "number"
      ? value
      : Number(String(value ?? "").replace(/[^0-9.-]/g, ""));

  return Number.isFinite(numericValue)
    ? numericValue.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : "0.00";
};

const Card = (props) => {
  const {
    loading = false,
    topText,
    topNumber,
    cardTitle,
    cardTitleNumber,
    cardTitleValueColor,
    cardTitleValue,
    cardBottomNumber,
    cardBottomName,
    topIndicatorVariant,
    cardTitleVariant,
    hideBottomBar,
    hideSecondBottomBar,
    secondBottomNumber,
    secondBottomName,
  } = props || {};

  const formattedValue = !loading ? formatNumber(cardTitleValue) : "0.00";
  const [whole, decimal] = formattedValue.split(".");

  const BigValueSkeleton = (
    <Skeleton.Input active style={{ width: 120, height: 32 }} />
  );

  const MediumValueSkeleton = (
    <Skeleton.Avatar
    active
    shape="circle"
    size={24}
    style={{ width: 24 }}
  />
  );

  const SmallValueSkeleton = (
  <Skeleton.Avatar
    active
    shape="circle"
    size={20}
    style={{ width: 20 }}
  />
);

  return (
    <div className="full-card-container">
      {/* TOP BAR */}
      {topText && (
        <div className="card-top-bar-container">
          <div className="card-top-text-indicator-container">
            <Text variant="tinyText">{topText}</Text>

            {loading ? (
              SmallValueSkeleton
            ) : (
              <ChangeIndicator
                variant={topIndicatorVariant ?? "white"}
                percent={topNumber ?? ""}
              />
            )}
          </div>

          {!loading && <RightArrowIcon className="quick-list-icon" />}
        </div>
      )}

      {/* MAIN CONTENT */}
      <div className="card-content-container">
        <div className="card-content-child-container">
          <Text variant="tinyText">{cardTitle}</Text>
        </div>

        <div className="card-top-text-indicator-container space-between-container">
          {loading ? (
            BigValueSkeleton
          ) : (
            <Text variant="numberBig" color={cardTitleValueColor ?? "darkText"}>
              ${whole}
              <Text variant="numbersSmall" color="strokeDark">
                .{decimal}
              </Text>
            </Text>
          )}

          {loading ? (
            MediumValueSkeleton
          ) : (
            cardTitleNumber && (
              <ChangeIndicator
                variant={cardTitleVariant ?? "white"}
                percent={cardTitleNumber}
              />
            )
          )}
        </div>
      </div>

      {/* BOTTOM BAR */}
      {!hideBottomBar && (
        <div className="card-bottom-bar-container">
          <Text variant="tinyText">Across</Text>

          {loading ? (
            SmallValueSkeleton
          ) : (
            <ChangeIndicator
              variant="white"
              percent={String(cardBottomNumber) ?? ""}
            />
          )}

          <Text variant="tinyText">{cardBottomName}</Text>
        </div>
      )}

      {/* SECOND BOTTOM BAR */}
      {hideSecondBottomBar &&
        (secondBottomNumber ? (
          <div className="card-bottom-bar-container">
            <Text variant="tinyText">Across</Text>

            {loading ? (
              SmallValueSkeleton
            ) : (
              <ChangeIndicator
                variant="white"
                percent={String(secondBottomNumber) ?? ""}
              />
            )}

            <Text variant="tinyText">{secondBottomName}</Text>
          </div>
        ) : (
          <div className="empty-card-bottom-bar" />
        ))}

      {hideBottomBar && <div className="empty-card-bottom-bar" />}
    </div>
  );
};

export default Card;